import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  setArchiveModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const CategoryMenu = ({ setModalOpen, setArchiveModalOpen }: Props) => {
  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis-horizontal" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        <PopoverMenu.TouchableOption
          title={i18n.t('common.edit')}
          onClick={() => setModalOpen(true)}
        />
        <PopoverMenu.TouchableOption
          title={i18n.t('common.archive')}
          danger
          onClick={() => setArchiveModalOpen(true)}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default CategoryMenu
